import React, { useEffect, useState } from 'react';

import subAbas from './subabas';
import BarraSubAbas from '../../../components/BarraSubAbas';
import ContainerConteudo from '../../../components/ContainerConteudo';
import Tabela from '../../../components/Tabela';
import { getAllLogsAcoes } from '../../../services/logs/logsAcoesService';
import { formatDate } from '../../../utils/functions';

const DadosAcessos: React.FC = () => {
  const [data, setData] = useState<any[]>([]);

  const headers = [
    { text: '', width: 1, key: '' },
    { text: 'ID', width: 2, key: 'id' },
    { text: 'Data/Hora', width: 10, key: 'dataAcao' },
    { text: 'Usuário', width: 10, key: 'nomeCompleto' },
    { text: 'Módulo', width: 10, key: 'interfaceSisAf' },
    { text: 'Entidade', width: 10, key: 'entidade' },
    { text: 'Registro (id)', width: 10, key: 'registroId' },
    { text: 'Ação', width: 10, key: 'tipoAcao' },
    { text: 'Detalhamento', width: 10, key: 'detalhamento' },
  ];

  // Função para buscar dados
  useEffect(() => {
    const fetchData = async () => {
      try {
        const logAcoesData = await getAllLogsAcoes();
        setData(logAcoesData);
      } catch (error) {
        console.error('Erro ao obter dados:', error);
      }
    };
    fetchData();
  }, []);

  // Dados da tabela
  const tableData = data.map((item) => ({
    ID: item.id,
    'Data/Hora': formatDate(item.dataAcao),
    Usuário: item.nomeCompleto,
    Módulo: item.interfaceSisAf,
    Entidade: item.entidade,
    'Registro (id)': item.registroId ?? '',
    Ação: item.tipoAcao,
    Detalhamento: item.detalhamento,
  }));

  // Dados do Offcanvas
  const offCanvasData = tableData;
  return (
    <>
      <BarraSubAbas subAbas={subAbas} />

      <ContainerConteudo>
        <Tabela
          headers={headers}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          rowClickable={false}
        />
      </ContainerConteudo>
    </>
  );
};
export default DadosAcessos;
